import Entity from '../entity'
export default class MetodoEnvio extends Entity<number>{
    
    metodoEnvio: string;
    descripcion: number;
    
}
